<script setup lang="ts">
import { computed } from 'vue';

/**
 * A refusal in the user's terms. Never a raw code — a code on screen is a bug
 * report, not an interface.
 *
 * `role="alert"` so a screen reader announces it when it appears: the user has
 * just pressed something and the answer is here, not where they are looking.
 */
const props = withDefaults(defineProps<{ tone?: 'warning' | 'info' }>(), { tone: 'warning' });

const tones = {
	warning: 'border-warning/40 bg-warning-bg text-warning',
	info: 'border-border text-muted',
} as const;

const classes = computed(() => `rounded-md border px-3 py-2 text-sm ${tones[props.tone]}`);
</script>

<template>
	<p :class="classes" role="alert"><slot /></p>
</template>
